<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" @click="handleCreate('')"
        >新增</el-button
      >
      <!-- <el-input
        v-model="listQuery.id"
        placeholder="ID"
        style="width: 180px;"
        class="filter-item"
        size="small"
        clearable
      />
      <el-input
        v-model="listQuery.email"
        placeholder="邮箱"
        style="width: 200px;"
        class="filter-item"
        size="small"
        clearable
      /> -->
      <!-- <el-date-picker
        class="filter-item"
        v-model="dateArr"
        type="datetimerange"
        :default-time="['00:00:00', '23:59:59']"
        align="right"
        value-format="yyyy-MM-dd HH:mm:ss"
        unlink-panels
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
      ></el-date-picker>
      <el-input
        v-model="listQuery.keyword"
        placeholder="请输入发行方名称"
        style="width: 200px"
        class="filter-item"
        clearable
      /> -->
      <!-- <el-select
        v-model="listQuery.is_normal"
        placeholder="状态"
        style="width: 90px"
        class="filter-item"
        size="small"
        clearable
      >
        <el-option label="正常" :value="1" />
        <el-option label="冻结" :value="0" />
      </el-select> -->
      <el-input
        v-model="listQuery.name"
        placeholder="请输入专区名称"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.is_on"
        placeholder="状态"
        clearable
        style="width: 150px"
        class="filter-item"
      >
        <el-option label="正常" :value="1" />
        <el-option label="已下架" :value="0" />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
    </div>
    <div style="margin-bottom: 5px">专区数量:{{ total }}</div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
      @cell-click="cellClick"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
          <!-- {{ scope.row.id }} -->
        </template>
      </el-table-column>
      <el-table-column label="权重" width="95" align="center">
        <template slot-scope="scope">
          <el-input
            ref="gain"
            size="mini"
            v-if="scope.row.isEdit"
            @blur="blurClick(scope)"
            :autofocus="true"
            v-model="scope.row.weight"
            oninput="value = value.replace(/[^\d]/g, '')"
          ></el-input>
          <span v-else>{{ scope.row.weight }}<i class="el-icon-edit"></i></span>
          <!-- {{ scope.$index + 1 }} -->
          <!-- {{ scope.row.sort_weight }} -->
        </template>
      </el-table-column>
      <!-- <el-table-column label="头像" min-width="60" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.avatar" class="user-avatar" />
        </template>
      </el-table-column> -->
      <el-table-column label="名称" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="封面" min-width="110" align="center">
        <template slot-scope="scope">
          <el-image
            class="user-avatar"
            :src="scope.row.cover"
            lazy
            :preview-src-list="[scope.row.cover]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_on == 1" type="success">正常</el-tag>
          <el-tag v-else type="danger">已下架</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="平台类型" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.platform_type == 'yc'" type="success"
            >艺术元创</el-tag
          >
          <el-tag v-else-if="scope.row.platform_type == 'ysj'" type="success"
            >艺术伽商城</el-tag
          >
          <el-tag v-else type="success">甄猫数藏</el-tag>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="区块链地址" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.chain_address }}
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="联系电话" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.account }}
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="创建时间" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="最新活跃时间" min-width="80" align="center">
        <template slot-scope="scope">
          {{ $moment( scope.row.last_login_at*1000).format("YYYY-MM-DD HH:mm:ss")}}
        </template>
      </el-table-column>
      <el-table-column label="邀请码" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.invitation_code||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="累计消费" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.total_pay_money }}
        </template>
      </el-table-column>
      <el-table-column label="实名认证" min-width="80" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_certification === 1" type="primary">是</el-tag>
          <el-tag v-else-if="scope.row.is_certification === 0" type="warning"
            >否</el-tag
          >
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="性别" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.gender === 0 || scope.row.gender === null">未设置</span>
          <span v-else-if="scope.row.gender === 1">男</span>
          <span v-else-if="scope.row.gender === 2">女</span>
          <span v-else>后端无字段</span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column
        class-name="status-col"
        label="用户状态"
        min-width="60"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_normal === 1" type="primary">正常</el-tag>
          <el-tag v-else-if="scope.row.is_normal === 0" type="warning"
            >冻结</el-tag
          >
          <el-tag v-else>后端无字段</el-tag>
        </template>
      </el-table-column> -->
      <!-- <el-table-column
        align="center"
        prop="created_at"
        label="注册时间"
        min-width="200"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column> -->
      <el-table-column
        label="操作"
        align="center"
        width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleUpdate(scope.row)"
          >
            修改
          </el-button>
          <el-button
            v-if="scope.row.is_on == 1"
            size="mini"
            type="danger"
            @click="handleStatus(scope.row.id, '下架')"
            >下架</el-button
          >
          <el-button
            v-else
            size="mini"
            type="success"
            @click="handleStatus(scope.row.id, '上架')"
            >上架</el-button
          >
          <!-- <el-button
            v-if="scope.row.is_normal === 1"
            type="warning"
            size="mini"
            @click="handleForbid(scope.row.id, '冻结')"
            >冻结</el-button
          >
          <el-button
            v-else
            size="mini"
            type="primary"
            @click="handleForbid(scope.row.id, '解冻')"
            >解冻</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :rules="rules" :model="form" label-width="180px">
        <el-form-item label="专区名称:" prop="name">
          <el-input type="text" v-model="form.name" maxlength="30" clearable />
        </el-form-item>
        <el-form-item label="封面(690*344)" prop="cover">
          <upload-one
            v-model="form.cover"
            style="width: 172px; height: 172px"
            heigth="172px"
            width="172px"
            accept=".gif,.jpg,.jpeg,.png,.GIF,.JPG,.PNG"
          ></upload-one>
        </el-form-item>
        <el-form-item label="图片(750*750)" prop="images">
          <upload-one
            v-model="form.images"
            style="width: 172px; height: 172px"
            heigth="172px"
            width="172px"
            accept=".gif,.jpg,.jpeg,.png,.GIF,.JPG,.PNG"
          ></upload-one>
        </el-form-item>
        <el-form-item label="创作者头像(40*40)" prop="creator_avatar">
          <upload-one
            v-model="form.creator_avatar"
            width="70px"
            height="70px"
            accept=".gif,.jpg,.jpeg,.png,.GIF,.JPG,.PNG"
          ></upload-one>
        </el-form-item>

        <el-form-item label="创作者姓名" prop="creator_name">
          <el-input
            v-model="form.creator_name"
            type="text"
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item label="简介" prop="introduce">
          <el-input
            v-model="form.introduce"
            placeholder="请输入简单介绍"
            type="textarea"
            :rows="4"
            style="width: 300px"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="权重" prop="weight">
          <el-input
            type="number"
            v-model="form.weight"
            style="width: 200px"
            :min="1"
            oninput="value = value.replace(/[^\d]/g, '')"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="平台类型" prop="platform_type">
          <el-select
            v-model="form.platform_type"
            placeholder="平台类型"
            clearable
            style="width: 150px"
            class="filter-item"
          >
            <el-option label="艺术元创" :value="'yc'" />
            <el-option label="艺术伽商城" :value="'ysj'" />
            <el-option label="甄猫数藏" :value="'zm'" />
          </el-select>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        id: "",
        email: "",
        nickname: "",
        is_normal: "",
        type: 2,
      },
      dateArr: null,
      dialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: "修改",
        create: "新增",
      },
      form: {
        id: "",
        name: "",
        weight: "",
        platform_type: "",
      },
      rules: {
        name: [
          { required: true, message: "专区名称不能为空", trigger: "blur" },
        ],
        cover: [
          { required: true, message: "专区封面不能为空", trigger: "blur" },
        ],
        images: [
          { required: true, message: "专区图片不能为空", trigger: "blur" },
        ],
        introduce: [
          { required: true, message: "专区简介不能为空", trigger: "blur" },
        ],
        creator_name: [
          {
            required: true,
            message: "专区创作者名称不能为空",
            trigger: "blur",
          },
        ],
        creator_avatar: [
          {
            required: true,
            message: "专区创作者头像不能为空",
            trigger: "blur",
          },
        ],
        weight: [{ required: true, message: "权重不能为空", trigger: "blur" }],
        platform_type: [
          { required: true, message: "平台类型不能为空", trigger: "blur" },
        ],
      },
      btnLoading: false,
    };
  },
  created() {
    this.getList();
  },
  watch: {
    dateArr(newVal, oldVal) {
      if (newVal) {
        this.listQuery.start_at = newVal[0];
        this.listQuery.end_at = newVal[1];
      } else {
        this.listQuery.start_at = "";
        this.listQuery.end_at = "";
      }
    },
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/product/categoryList",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
        this.btnLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    resetForm() {
      this.form = {
        id: "",
        nickname: "",
      };
      this.btnLoading = false;
    },
    handleCreate() {
      this.resetForm();
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    handleUpdate(row) {
      this.resetForm();
      this.form = Object.assign({}, row);
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    saveData() {
      // if (this.form.link_type && !this.form.link) {
      //   this.$message({
      //     type: "error",
      //     message: "跳转链接不能为空",
      //   });
      //   return;
      // }
      // if (!this.form.link_type) {
      //   this.form.link = "";
      // }
      // if (this.form.effective_duration_num == 0) {
      //   this.$message({
      //     type: "error",
      //     message: "会员有效时长请大于或等于1",
      //   });
      //   return;
      // }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/product/categoryStore",
            method: "post",
            data: this.form,
          })
            .then((response) => {
              this.dialogFormVisible = false;
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getList();
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        }
      });
    },
    //上下架
    handleStatus(val, text) {
      this.$confirm("此操作将" + text + "该专区, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/product/categoryUpDown",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
    handleForbid(val, text) {
      this.$confirm("此操作将" + text + "该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/users/changeNormal",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    cellClick(row, column, event) {
      if (column.label === "权重") {
        this.$set(row, "isEdit", true);
      }
      this.$forceUpdate();
    },
    blurClick({ row, column }) {
      this.$set(row, "isEdit", false);
      if (row.sort_weight <= 0) {
        this.$message.error("权重必须大于或者等于1");
        return;
      }
      request({
        url: "/api/backend/product/categoryStore",
        method: "post",
        data: { id: row.id, name: row.name, weight: row.weight },
      }).then(() => {
        this.getList();
        this.$forceUpdate(); //强制更新
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
